var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.checked)?_c('img',{staticClass:"title-icon",attrs:{"src":require("@/assets/images/M3/M3Sketch/checkmark.png")}}):_c('img',{staticClass:"title-icon",attrs:{"src":require("@/assets/images/M3/M3Sketch/warn.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }